import { styleConstant } from 'Pages/landings/common/styles/styleConstants'
import { isEmptyValue } from 'Helpers'

export type ThemeObject = typeof themeObject
export type Theme = { theme: ThemeObject }

export enum Breakpoints {
	xs = '360px',
	sm = '576px',
	md = '768px',
	lg = '992px',
	xl = '1200px',
	xxl = '1920px',
}

export enum NewBreakpoints {
	sm = '360px',
	ms = '768px',
	lx = '1024px',
	xl = '1280px',
	xxl = '1920px',
}

export const themeObject = {
	...styleConstant,
}

export const getFromTheme =
	(variable: keyof typeof styleConstant.common) =>
	({ theme }: Theme) =>
		theme[variable]

export type Color = keyof typeof styleConstant.color
export type Palette = keyof typeof styleConstant.palette
export type StyledThemeFn = ({ theme }: Theme) => string

export function getColorOrPalette(name: Color): StyledThemeFn
export function getColorOrPalette(name: Palette, index: number): StyledThemeFn
export function getColorOrPalette(name: Palette | Color, index?: number) {
	return ({ theme }: Theme) =>
		!isEmptyValue(index) ? theme.palette[name][index] : theme.color[name]
}

/**
 * @ex getColor('gray_1' | 'white')
 * @param color
 */
export const getColor = (color: string) =>
	/_/.test(color)
		? getColorOrPalette(color.split('_')[0] as Palette, Number(color.split('_')[1]))
		: getColorOrPalette(color as Color)

export const getFontFamily =
	(name: keyof typeof styleConstant.fontFamily) =>
	({ theme }: Theme) =>
		theme.fontFamily[name]

export const getFontWeight =
	(name: keyof typeof styleConstant.fontWeight) =>
	({ theme }: Theme) =>
		theme.fontFamily[name]
